import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import { useSession } from '../../context/SessionContext';
import VTOLoginConfirmationPortal from '../virtual-try-on/VTOLoginConfirmationPortal';
import './SessionExpiredModal.css';

const SessionExpiredModal = () => {
    const { isSessionExpired, clearSessionExpired } = useSession();
    const [showLoginModal, setShowLoginModal] = useState(false);

    // Prevent body scroll when modal is open
    useEffect(() => {
        if (isSessionExpired) {
            document.body.style.overflow = 'hidden';
        }
        return () => {
            document.body.style.overflow = '';
        };
    }, [isSessionExpired]);

    const handleReLogin = () => {
        // Clear stored credentials
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        localStorage.removeItem('auth_token');
        localStorage.removeItem('auth_user');
        localStorage.removeItem('auth_timestamp');

        // Clear the expired state
        clearSessionExpired();

        // Show inline login modal
        setShowLoginModal(true);
    };

    const handleLoginSuccess = () => {
        setShowLoginModal(false);
        window.location.reload();
    };

    if (!isSessionExpired && !showLoginModal) return null;

    const modalContent = isSessionExpired ? (
        <div className="session-expired-overlay">
            <div className="session-expired-card">
                <div className="session-expired-container">
                    {/* Lock icon */}
                    <div className="session-expired-icon-wrapper">
                        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#00b5ad" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                            <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
                            <path d="M7 11V7a5 5 0 0 1 10 0v4" />
                        </svg>
                    </div>

                    <h2 className="session-expired-title">Session Expired</h2>

                    <p className="session-expired-message">
                        Your session has expired due to inactivity or security reasons.
                    </p>
                    <p className="session-expired-submessage">
                        Please log in again to continue using your closet.
                    </p>

                    <button
                        className="session-expired-login-btn"
                        onClick={handleReLogin}
                    >
                        Log In Again
                    </button>
                </div>
            </div>
        </div>
    ) : null;

    return (
        <>
            {modalContent && ReactDOM.createPortal(modalContent, document.body)}

            <VTOLoginConfirmationPortal
                isOpen={showLoginModal}
                onLogin={handleLoginSuccess}
                onCancel={() => setShowLoginModal(false)}
                onClose={() => setShowLoginModal(false)}
            />
        </>
    );
};

export default SessionExpiredModal;
